import { render } from "./FrontOffices.vue?vue&type=template&id=7fca2048&scoped=true"
import script from "./FrontOffices.vue?vue&type=script&lang=js"
export * from "./FrontOffices.vue?vue&type=script&lang=js"

import "./FrontOffices.vue?vue&type=style&index=0&id=7fca2048&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7fca2048"

export default script